module.exports={"(optional)":"（オプション）","(required)":"（必須）"};